import React, { useEffect } from 'react';

/**
 * Shared wrapper for all legal pages (Terms of Service, Privacy Policy,
 * Cookie Policy). Renders a page-level hero band with the title and then
 * the body content. Inherits the global Navigation + Footer from the
 * top-level <Layout> in App.js, so it feels like a natural part of the site.
 */
const LegalPage = ({ title, html }) => {
  // Land at the top of the legal page when navigated to.
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, []);

  return (
    <div className="bg-white">
      {/* Page hero band — matches the soft sage tone used elsewhere */}
      <section className="bg-[#F5F7F5] border-b border-black/5">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 py-20 md:py-24">
          <p className="text-xs font-medium tracking-[0.18em] uppercase text-[#B45369] mb-4">
            Legal
          </p>
          <h1
            className="text-4xl md:text-5xl font-light text-black/90 leading-tight"
            data-testid="legal-page-title"
          >
            {title}
          </h1>
        </div>
      </section>

      {/* Body content */}
      <section className="bg-white">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 py-12 md:py-16">
          <article
            className="legal-doc"
            data-testid="legal-page-body"
            dangerouslySetInnerHTML={{ __html: html }}
          />
        </div>
      </section>
    </div>
  );
};

export default LegalPage;
